import styled from 'styled-components'
import ModalLayout from './ModalLayout'
import Text from '../../atoms/Text'
import MainButton from '../../atoms/MainButton'

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 8px;
`
const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  gap: 8px;
`
const DeleteModal = ({ onClose, onConfirm, title="단어" }) => {
  return (
    <ModalLayout>
      <>
        <TextWrapper>
          <Text variant="headline3" weight="bold">삭제할까요?</Text>
          <Text>삭제한 {title} 기록은 복원할 수 없어요.</Text>
        </TextWrapper>
        <ButtonWrapper>
          <MainButton
            $variant="cancel"
            $size="small"
            title="취소"
            onClick={onClose}/>
          <MainButton
            $variant="destructive"
            $size="small"
            title="삭제"
            onClick={onConfirm}/>
        </ButtonWrapper>
      </>
    </ModalLayout>
  )
}

export default DeleteModal
